import { Color } from '@persona-id/design-tokens';
import BellIcon from '@persona-id/design-tokens/icons/BellIcon';
import Lottie from 'lottie-react';
import styled, { css } from 'styled-components';

import { Paragraph } from 'design-system/components/Text';
import AnimationBell from 'images/dashboard/animation-bell.json';

const Wrapper = styled('div')`
  flex: 1;
  position: relative;
`;

const AlertCircle = styled('div')<{ size: 'sm' | 'md' | 'lg' }>`
  display: flex;
  position: absolute;
  border: 1px solid ${({ theme }) => theme.color.background.primary};
  width: 11px;
  height: 11px;
  background-color: ${Color.CoreRed800};
  border-radius: 50%;
  right: 6px;
  top: 5px;

  ${({ size }) =>
    size === 'md' &&
    css`
      width: 14px;
      height: 13px;
      right: 4px;
      top: 4px;
    `}

  ${({ size }) =>
    size === 'lg' &&
    css`
      width: 19px;
      height: 16px;
      right: -1px;
      top: 1px;
      border-radius: 7px;
    `}
`;

const AlertText = styled(Paragraph)<{ size: 'sm' | 'md' | 'lg' }>`
  color: ${Color.PrimaryWhite};
  font-weight: 500;
  font-size: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 10px;
  width: 10px;

  ${({ size }) =>
    size === 'md' &&
    css`
      width: 12px;
      height: 11px;
    `}

  ${({ size }) =>
    size === 'lg' &&
    css`
      width: 17px;
      height: 14px;
    `}
`;

export interface NotificationBellProps {
  unreadCount: number;
}

const NotificationBell = ({ unreadCount }: NotificationBellProps) => {
  const size = unreadCount < 10 ? 'sm' : unreadCount < 100 ? 'md' : 'lg';

  if (unreadCount > 0) {
    return (
      <Wrapper>
        <Lottie title='BellAnimation' animationData={AnimationBell} loop={4} />
        <AlertCircle size={size}>
          <AlertText
            size={size}
            data-test='notification-bell-badge'
            aria-label='Unread notifications'
          >
            {unreadCount < 100 ? unreadCount : '99+'}
          </AlertText>
        </AlertCircle>
      </Wrapper>
    );
  } else {
    return <BellIcon />;
  }
};

export default NotificationBell;
